import { isArray } from 'util';
import { MaterialChange } from '../material-change';
import { ChangedAttribute } from '../changed-attribute';
import { ChangedItem } from '../changed-item';

export class MaterialChangeBuilder {
  static fromJson(json) {
    return (json)
      ? new MaterialChange(
        MaterialChangeBuilder.builChangedMaterialsFromList(json.changes),
        json.initial,
        json.existingFilesAmount
      )
      : null;
  }

  static builChangedMaterialsFromList(list) {
    return (isArray(list)) ? list.map(MaterialChangeBuilder.changedAttributeBuilderFromJson) : [];
  }

  static changedAttributeBuilderFromJson(json) {
    return (json)
      ? new ChangedAttribute(
        json.fileName,
        MaterialChangeBuilder.builChangedItemFromList(json.changes)
      )
      : null;
  }

  static builChangedItemFromList(list) {
    return (isArray(list)) ? list.map(MaterialChangeBuilder.changedItemBuilderFromJson) : [];
  }

  static changedItemBuilderFromJson(json) {
    return (json)
      ? new ChangedItem(
        json.changedAttribute,
        json.oldValue,
        json.newValue,
      )
      : null;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/material-change.builder.ts